// extracted by mini-css-extract-plugin
export default {"main":"ModalEventoCalendario_main__2xTyk","title":"ModalEventoCalendario_title__AAWSG","intro":"ModalEventoCalendario_intro__gvnHG","input":"ModalEventoCalendario_input__5pR48"};